import React, {useEffect, useState} from 'react';
import {Link, withRouter} from 'react-router-dom'
import {connect} from 'react-redux';
import {clearFailedLogin, login, waitForLogin} from './../../../state/actions/authActions';
import {Button, Card, CardActions, CardContent, CircularProgress, TextField, Typography,} from '@mui/material';

function LoginForm(props) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (props.isLoggedIn) {
      props.history.push('/explore')
    }
  })

  const handleLogin = () => {
    if (props.failedLogin) {
      props.clearFailedLogin()
    }
    props.waitForLogin()
    props.login(username, password)
  }

  return (
    <div style={{maxWidth: 400, margin: '0 auto', marginTop: 64}}>
      <Card style={{borderTop: '1px solid rgba(0,0,0,0.12)'}}>
        <form onKeyDown={event => (event.keyCode === 13) && handleLogin()} autoComplete="off">
        <CardContent>
          <h2 style={{fontWeight: '400', marginTop: 0}}>Login</h2>
          {
            props.failedLogin
            && props.failedLoginMessage
            && <Typography id="loginErrors" color="textSecondary" gutterBottom style={{backgroundColor: '#ffbdbd', padding: '4px 8px', borderRadius: '4px'}}>
                  { props.failedLoginMessage }
                </Typography>
          }
          <div>
            <TextField
              id='username'
              label='Username or email'
              fullWidth
              value={username}
              onChange={event => {setUsername(event.target.value)}}
              margin='normal'
              variant='outlined'
            />
          </div>
          <div>
            <TextField
              id='password'
              label='Password'
              fullWidth
              type='password'
              value={password}
              onChange={event => {setPassword(event.target.value)}}
              margin='normal'
              variant='outlined'
            />
          </div>
        </CardContent>
        <CardActions>
          <div style={{padding: 8, position: 'relative'}}>
            <Button variant='contained' color='primary' disabled={props.loginInProgress} onClick={handleLogin} >Login</Button>
            { props.loginInProgress
              && <CircularProgress size={24} style={{position: 'absolute', top: '50%', left: '50%', marginTop: -12, marginLeft: -12}}/>}
          </div>
            <Link to="/login/reset-password">Forgot password?</Link>
        </CardActions>
        </form>
      </Card>
    </div>
  )
}

const mapStateToProps = state => ({
  isLoggedIn: state.auth.uid,
  failedLogin: state.auth.failedLogin,
  failedLoginMessage: state.auth.failedLoginMessage,
  loginInProgress: state.auth.loginInProgress,
});

const mapDispatchToProps = {
  clearFailedLogin,
  waitForLogin,
  login
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LoginForm));